export const ONE_SECOND_IN_MS = 1000;
export const TWO_SECONDS_IN_MS = 2 * ONE_SECOND_IN_MS;
export const THREE_SECONDS_IN_MS = 3 * ONE_SECOND_IN_MS;
export const FOUR_SECONDS_IN_MS = 4 * ONE_SECOND_IN_MS;
export const FIVE_SECONDS_IN_MS = 5 * ONE_SECOND_IN_MS;

export const isMajority = (birt: Date, current: Date): boolean => {
  const diffYear = current.getFullYear() - birt.getFullYear();
  const birtMonth = birt.getMonth() + 1;
  const birtDays = birt.getDate();
  const currentMonth = current.getMonth() + 1;
  const currentDays = current.getDate();

  if (diffYear > 18) {
    return true;
  }

  if (diffYear === 18) {
    if (birtMonth < currentMonth) {
      return true;
    }

    if (birtMonth === currentMonth) {
      return birtDays <= currentDays;
    }
  }
  return false;
};

export const diff = (date: Date, diffType: 'years' | 'seconds'): number => {
  let nowDate = new Date();
  let diff = 0;
  switch (diffType) {
    case 'years':
      diff = nowDate.getFullYear() - date.getFullYear();
      break;
    case 'seconds':
      diff = Math.floor(
        (nowDate.getMilliseconds() - date.getMilliseconds()) / 1000
      );
      break;
  }
  return diff;
};

export const yearsOld = (date: Date): number => {
  const timeDiff = Math.abs(Date.now() - date.getTime());
  const age = Math.floor(timeDiff / (1000 * 3600 * 24) / 365.25);
  return age;
};

export const formatBirth = (value: string): string => {
  if (!value) {
    return '';
  }
  value = value.replace(/\D/g, '');
  value = value.replace(/(\d{2})(\d)/, '$1/$2');
  value = value.replace(/(\d{2})(\d)/, '$1/$2');
  return value;
};

export const getDateIso = (value: string): string => {
  if (!value) {
    return '';
  }
  value = value.replace(/\D/g, '');
  const day = value.substring(0, 2);
  const month = value.substring(2, 4);
  const year = value.substring(4, 8);
  return `${year}-${month}-${day}`;
};
